const SCRIPT_INITIALIZE = 'initialize';
const SCRIPT_POST_INITIALIZE = 'postInitialize';
const SCRIPT_UPDATE = 'update';
const SCRIPT_POST_UPDATE = 'postUpdate';
const SCRIPT_SWAP = 'swap';

export { SCRIPT_INITIALIZE, SCRIPT_POST_INITIALIZE, SCRIPT_POST_UPDATE, SCRIPT_SWAP, SCRIPT_UPDATE };
